/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SchemaAttachmentDto
 */
export interface SchemaAttachmentDto {
    /**
     * 
     * @type {string}
     * @memberof SchemaAttachmentDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SchemaAttachmentDto
     */
    schemaSlug?: string;
    /**
     * 
     * @type {string}
     * @memberof SchemaAttachmentDto
     */
    purpose?: string;
    /**
     * 
     * @type {string}
     * @memberof SchemaAttachmentDto
     */
    targetType?: string;
    /**
     * 
     * @type {string}
     * @memberof SchemaAttachmentDto
     */
    targetId?: string;
    /**
     * 
     * @type {string}
     * @memberof SchemaAttachmentDto
     */
    targetName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SchemaAttachmentDto
     */
    active?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SchemaAttachmentDto
     */
    metadata?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof SchemaAttachmentDto
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof SchemaAttachmentDto
     */
    updatedBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof SchemaAttachmentDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SchemaAttachmentDto
     */
    updatedAt?: Date;
}

/**
 * Check if a given object implements the SchemaAttachmentDto interface.
 */
export function instanceOfSchemaAttachmentDto(value: object): value is SchemaAttachmentDto {
    return true;
}

export function SchemaAttachmentDtoFromJSON(json: any): SchemaAttachmentDto {
    return SchemaAttachmentDtoFromJSONTyped(json, false);
}

export function SchemaAttachmentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SchemaAttachmentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'schemaSlug': json['schemaSlug'] == null ? undefined : json['schemaSlug'],
        'purpose': json['purpose'] == null ? undefined : json['purpose'],
        'targetType': json['targetType'] == null ? undefined : json['targetType'],
        'targetId': json['targetId'] == null ? undefined : json['targetId'],
        'targetName': json['targetName'] == null ? undefined : json['targetName'],
        'active': json['active'] == null ? undefined : json['active'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function SchemaAttachmentDtoToJSON(json: any): SchemaAttachmentDto {
    return SchemaAttachmentDtoToJSONTyped(json, false);
}

export function SchemaAttachmentDtoToJSONTyped(value?: SchemaAttachmentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'schemaSlug': value['schemaSlug'],
        'purpose': value['purpose'],
        'targetType': value['targetType'],
        'targetId': value['targetId'],
        'targetName': value['targetName'],
        'active': value['active'],
        'metadata': value['metadata'],
        'createdBy': value['createdBy'],
        'updatedBy': value['updatedBy'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
    };
}

